export interface AppConfig {
  apiBaseUrl: string
  routePrefix: string
}

const defaultConfig: AppConfig = {
  apiBaseUrl: '/api',
  routePrefix: '',
}

const getEnvVar = (key: string, defaultValue: string): string => {
  if (typeof window !== 'undefined') {
    return (window as any).__VITE_ENV__?.[key] ?? defaultValue
  }

  if (typeof process !== 'undefined' && process.env) {
    return process.env[key] ?? defaultValue
  }

  return defaultValue
}

export const config: AppConfig = {
  apiBaseUrl: getEnvVar('VITE_API_BASE_URL', defaultConfig.apiBaseUrl),
  routePrefix: getEnvVar('VITE_ROUTE_PREFIX', defaultConfig.routePrefix),
}
